import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import { IPageStatus } from '@elem/compPage/delta-3-max-series/config/IPageStatus';
import EcoButton from 'eco-design/base/eco-button';
import React, { useEffect, useRef, useState } from 'react';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useProductStore } from '../../../../../ProductStationProvider';
import { getMemberListProducts } from '../../../../../service';
import { CreditsH5Icon, CreditsIcon } from '../../components/icons';
import { productSeriesConf } from '../../productData';
import styles from './index.module.scss';

import getLocal from '@/app/utils/i18n';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import EcoImg from 'eco-design/base/eco-img';

interface ProductBundlesIProps {
    addShopCartCallback: (card: any, listName?: string) => void;
}
const ProductBundles: React.FC<ProductBundlesIProps> = ({ addShopCartCallback }) => {
    const { isMobile } = useGlobal();
    const { locale } = getLocal();
    const getVids = () => productSeriesConf[locale]?.map((item) => item.variantId);
    const [productList, setProductList] = useState<any>([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const { pageStatus } = useProductStore();
    const { t } = useLang('Delta3MaxSeriesStation.productBundles');

    const productConfigs: any = {
        52157995123055: {
            title: 'DELTA 3 Max Plus (2048Wh)',
            desc: '2,048Wh 容量 | 3,000W 出力（サージ6,000W）\n1,500W AC入力 & 1,000Wソーラー入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            swiper: [0, 1, 2],
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1757417867523/D3MP.png',
                'https://websiteoss.ecoflow.com/upload/image/1757417322487/sec-prod-1-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1757472407783/Group%201000008361-pc.png',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1757417867523/D3MP.png',
                'https://websiteoss.ecoflow.com/upload/image/1757417322306/sec-prod-1-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1757472414765/Group%201612707022-m.png',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1757417867523/D3MP.png',
                'https://websiteoss.ecoflow.com/upload/image/1757417322306/sec-prod-1-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1757472414765/Group%201612707022-m.png',
            ],
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-plus-portable-power-station',
        },
        52156760129903: {
            title: 'DELTA 3 Max (2048Wh)',
            desc: '2,048Wh 容量 | 2,200W 出力（サージ4,400W）\n1,500W AC入力 & 1,000W ソーラー入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            swiper: [0, 1, 2],
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-portable-power-station',
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1757417879455/D3M.png',
                'https://websiteoss.ecoflow.com/upload/image/1757417322890/sec-prod-2-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1757472407783/Group%201000008361-pc.png',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1757417879455/D3M.png',
                'https://websiteoss.ecoflow.com/upload/image/1757417322687/sec-prod-2-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1757472414765/Group%201612707022-m.png',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1757417879455/D3M.png',
                'https://websiteoss.ecoflow.com/upload/image/1757417322687/sec-prod-2-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1757472414765/Group%201612707022-m.png',
            ],
        },
        52157995680111: {
            title: 'DELTA 3 Max Plus (2048Wh) + 400Wソーラーパネル',
            desc: '2,048Wh 容量 | 3,000W 出力（サージ6,000W）\n1,500W AC入力 & 1,000Wソーラー入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-plus-400w-solar-panel',
        },
        52157998104943: {
            title: 'DELTA 3 Max Plus (2048Wh) + 専用エクストラバッテリー',
            desc: '4,096Wh 容量 | 3,000W 出力（サージ6,000W）\n1,500W AC入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-plus-extra-battery-bundle',
        },
        52158000202095: {
            title: 'DELTA 3 Max Plus (2048Wh) + 800W Alternator Charger',
            desc: '2,048Wh 容量 | 3,000W 出力（サージ6,000W）\n1,500W AC入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-plus-800w-alternator-charger',
        },
        52158005084527: {
            title: 'DELTA 3 Max Plus (2048Wh) + 専用エクストラバッテリー+ 400Wソーラーパネル',
            desc: '4,096Wh 容量 | 3,000W 出力（サージ6,000W）\n1,500W AC入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-plus-extra-battery-400w-solar-panel-bundle',
            hasTag: true,
        },
        52158022943087: {
            title: 'DELTA 3 Max (2048Wh) + + 400Wソーラーパネル',
            desc: '2,048Wh 容量 | 2,200W 出力（サージ4,400W）\n1,500W AC入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-400w-solar-panel',
        },
        52158019797359: {
            title: 'DELTA 3 Max (2048Wh) + 500W Alternator Charger',
            desc: '2,048Wh 容量 | 2,200W 出力（サージ4,400W）\n1,500W AC入力\n10ミリ秒未満の電源自動切り替え機能\n5年間の保証付き',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-500w-alternator-charger',
        },
    };

    const getProductData = () => {
        if (!getVids()) return;

        try {
            getMemberListProducts(
                {
                    variantIds: getVids(),
                },
                locale,
            ).then((res) => {
                if (res.code === '0' && res.data) {
                    const list = Object.keys(productConfigs).map((item: any) => {
                        const findItem = res.data.find((v: any) => v.variantId === item) || {};
                        return {
                            ...productConfigs[item],
                            ...findItem,
                            buyUrl: `https://${locale}.ecoflow.com/cart/${findItem.variantId}:1?channel=buy_button`,
                        };
                    });
                    setProductList(list);
                }
            });
        } catch (error) {
            console.log('error->>', error);
        }
    };

    const getDescContent = (text: string, type?: number) => {
        const arr = text.split(/\r?\n/);
        if (!type) {
            return arr[0];
        }
        return arr.slice(1).join('\n');
    };

    const formatPrice = (num: number) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const getDiscount = (price: number, comparePrice: number) => {
        if (price <= 0) return 0;
        if (comparePrice <= 0) return 0;

        const discount = Math.round((1 - price / comparePrice) * 100);
        return discount;
    };

    const getEcocredits = (price: number) => {
        if (price <= 0) return 0;
        return Math.round((price / 150) * 5)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const handleAddCart = (info: any, listName: string, className2: string) => {
        addShopCartCallback(
            {
                ...info,
                discountPrice: info.price,
                originalPrice: info.compareAtPrice,
                variantId: info.variantId,
                inventory: info.inventoryQuantity,
                inventoryPolicy: info.inventoryPolicy,
                img: info.img,
                title: info.skuTitle,
                buyText: 'カートに入れる', //埋点好像需要用这个呀
                className2,
            },
            listName,
        );
    };

    const handlePushGtm = (product: string, url: string, listName: string, className2: string) => {
        saveCookieForShopify(url, locale);
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: product,
            position: listName,
            __btn_type: 'href',
            __btn_id1: className2,
            __btn_id2: url,
        });
    };

    useEffect(() => {
        getProductData();
        if (typeof window !== 'undefined') {
            window.scrollTo({
                top: 0,
                behavior: 'smooth', // 平滑滚动
            });
        }
    }, []);

    useEffect(() => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        setProgress(0);

        intervalRef.current = setInterval(() => {
            setProgress((prev) => Math.min(prev + 0.02, 1));
        }, 60);

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [activeIndex]);

    return (
        <section className={styles.ProductBundles}>
            <div className="bundles-title">DELTA 3 Max (2048Wh) シリーズ</div>
            <div className="card-section">
                {productList.slice(0, 2).map((item: any, index: number) => (
                    <div className={`card-line ${index === 1 ? 'card-line-rever' : ''}`} key={item.variantId}>
                        <div className="left-box prod-desc">
                            {isMobile && (
                                <div className="top-box">
                                    <div className="item-discount">
                                        <span>{getDiscount(item.price, item.compareAtPrice)}%</span>
                                        <span className="unit">OFF</span>
                                    </div>
                                    <div className="item-credits">
                                        <span className="item-icon">
                                            <CreditsH5Icon />
                                        </span>
                                        <span className="num">5倍</span>
                                        <span className="credits-box">
                                            <span className="credits-num">{getEcocredits(item.price)}</span>
                                            <span className="credits-text">ポイント</span>
                                        </span>
                                    </div>
                                </div>
                            )}
                            <div className="item-title">{item.title}</div>
                            <div className="item-desc">{item.desc}</div>
                            <div className="item-price">
                                <div className="price">
                                    <span>￥{formatPrice(item.price)}</span>
                                    <span className="tax">（税込）</span>
                                </div>
                                <div className="compare-price">
                                    <span>通常価格￥{formatPrice(item.compareAtPrice)}</span>
                                    <span className="tax">（税込）</span>
                                </div>
                            </div>
                            <div className="item-btn-box">
                                <EcoButton
                                    lType="outlined"
                                    className={`GtmModuleData-btn-href item-btn-opt line-item-l-${index + 1} ${item?.inventoryQuantity ? '' : 'disabled'}`}
                                    lHref={item.learnMore}
                                    onClick={() => handlePushGtm(`${item.title}`, item.learnMore, `DELTA 3 Max (2048Wh) シリーズ`, `line-item-l-${index + 1}`)}
                                >
                                    {pageStatus === IPageStatus.statusB ? t('buy_btn_detail') : t('buy_btn1')}
                                </EcoButton>
                                <EcoButton
                                    lType="filled"
                                    className={`GtmModuleData-btn-common item-btn-opt line-item-r-${index + 1} ${item?.inventoryQuantity ? '' : 'disabled'}`}
                                    onClick={() => handleAddCart(item, `DELTA 3 Max (2048Wh) シリーズ`, `line-item-r-${index + 1}`)}
                                    data-btn-id={`line-item-r-${index + 1}`}
                                >
                                    {t('add_card')}
                                </EcoButton>
                            </div>
                        </div>
                        <div className="right-box prod-swiper">
                            {!isMobile && (
                                <div className="top-box">
                                    <div className="item-discount">
                                        <span>{getDiscount(item.price, item.compareAtPrice)}%</span>
                                        <span className="unit">OFF</span>
                                    </div>
                                    <div className="item-credits">
                                        <span className="item-icon">
                                            <CreditsIcon />
                                        </span>
                                        <span className="num">5倍</span>
                                        <span className="credits-box">
                                            <span className="credits-num">{getEcocredits(item.price)}</span>
                                            <span className="credits-text">ポイント</span>
                                        </span>
                                    </div>
                                </div>
                            )}
                            <Swiper
                                modules={[Pagination, Autoplay]}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                slidesPerView={1}
                                // pagination={{ clickable: true }}
                                onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                            >
                                {item.swiper.map((v: any, i: number) => (
                                    <SwiperSlide className="prod-swiper-slide" key={i}>
                                        <div className="img-box">
                                            <EcoImg className={`item-img img-${i}`} pc={item.pc[v]} pad={item.pad[v]} h5={item.h5[v]}></EcoImg>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            {/* 自定义进度条分页 */}
                            <div className="custom-pagination">
                                {item.swiper.map((i: number) => (
                                    <div key={i} className={`bullet ${activeIndex === i ? 'active' : ''}`}>
                                        {activeIndex === i && <span className="progress" style={{ transform: `scaleX(${progress})` }} />}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="card-list">
                <div className="card-list-title">DELTA 3 Max (2048Wh) シリーズのセット</div>
                <div className="card-list-content">
                    {productList.slice(2).map((item: any, index: number) => {
                        return (
                            <div className="item-card" key={item.variantId}>
                                <div className="item-car-top">
                                    {!isMobile && (
                                        <div className="top-box">
                                            <div className="item-discount">
                                                <span>{getDiscount(item.price, item.compareAtPrice)}%</span>
                                                <span className="unit">OFF</span>
                                            </div>
                                            <div className="item-credits">
                                                <span className="item-icon">
                                                    <CreditsIcon />
                                                </span>
                                                <span className="num">5倍</span>
                                                <span className="credits-box">
                                                    <span className="credits-num">{getEcocredits(item.price)}</span>
                                                    <span className="credits-text">ポイント</span>
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    <div className="product-img-box">
                                        <div className="product-img">
                                            <EcoImg pc={item.variantImg} alt={item.skuTitle}></EcoImg>
                                        </div>
                                    </div>
                                    <div className="desc-box">
                                        <div className="tag-box">
                                            {isMobile && (
                                                <div className="top-box">
                                                    <div className="item-discount">
                                                        <span>{getDiscount(item.price, item.compareAtPrice)}%</span>
                                                        <span className="unit">OFF</span>
                                                    </div>
                                                    <div className="item-credits">
                                                        <span className="item-icon">
                                                            <CreditsH5Icon />
                                                        </span>
                                                        <span className="num">5倍</span>
                                                        <span className="credits-box">
                                                            <span className="credits-num">{getEcocredits(item.price)}</span>
                                                            <span className="credits-text">ポイント</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                            {item.hasTag && (
                                                <div className="product-tag">
                                                    <span>公式オンラインストア限定</span>
                                                </div>
                                            )}
                                        </div>

                                        <div className="item-card-title">{item.skuTitle}</div>
                                        <p className="item-card-desc-1">{getDescContent(item.desc)}</p>
                                        <p className="item-card-desc">{getDescContent(item.desc, 1)}</p>
                                    </div>
                                </div>
                                <div className="item-card-bottom">
                                    <div className="price-box">
                                        <p className="price">￥{formatPrice(item.price)}（税込）</p>
                                        <p className="compare-price">通常価格￥{formatPrice(item.compareAtPrice)}（税込）</p>
                                    </div>
                                    <div className="item-btn-box">
                                        <EcoButton
                                            lType="outlined"
                                            className={`GtmModuleData-btn-href item-btn-opt list-item-l-${index + 1} ${
                                                item?.inventoryQuantity ? '' : 'disabled'
                                            }`}
                                            lHref={item.learnMore}
                                            onClick={() =>
                                                handlePushGtm(
                                                    `${item.title}`,
                                                    item.learnMore,
                                                    `DELTA 3 Max (2048Wh) シリーズのセット`,
                                                    `list-item-l-${index + 1}`,
                                                )
                                            }
                                        >
                                            {pageStatus === IPageStatus.statusB ? t('buy_btn_detail') : t('buy_btn1')}
                                        </EcoButton>
                                        <EcoButton
                                            lType="filled"
                                            className={`GtmModuleData-btn-common item-btn-opt list-item-r-${index + 1} ${
                                                item?.inventoryQuantity ? '' : 'disabled'
                                            }`}
                                            onClick={() => handleAddCart(item, `DELTA 3 Max (2048Wh) シリーズのセット`, `list-item-r-${index + 1}`)}
                                            data-btn-id={`list-item-r-${index + 1}`}
                                        >
                                            {t('add_card')}
                                        </EcoButton>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ProductBundles;
